<div class="container">
  <div class="row">
    <div class="col-sm-12">
      <h4>Stammdaten</h4>
    </div>
  </div>
  <div class="row">
    <div class="col-sm-12">

      <mat-tab-group (selectedTabChange)="tabChanged($event)">
        <mat-tab label="Basis">
          <div *ngIf="client">
            <div class="row" style="margin-top: 35px;">
              <div class="col-sm-4" *ngFor="let p of imageProperties">

                <mat-card appearance="outlined" class="example-card">
                  <mat-card-title> {{ p.showValue }}</mat-card-title>
                  <mat-card-content>
                    <div>
                      <img [src]="p.value" *ngIf="p.value" style="height: 50px; margin: 10px 0;">
                      <div class="caption">
                      </div>
                    </div>
                    <!-- <span style="padding: 10px 0;">
                      {{ p.hint }}
                    </span> -->

                  </mat-card-content>
                  <mat-card-actions>
                    <button mat-button (click)="openImageGallery(p)" color="primary"> Anderes Bild auswählen</button>
                    <button mat-button (click)="saveImage(p)" [disabled]="!p.hasChanged"
                      color="primary">Speichern</button>
                  </mat-card-actions>
                </mat-card>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <mat-card appearance="outlined" class="example-card">
                  <mat-card-title> Name</mat-card-title>
                  <mat-card-subtitle> Name des Clients bspw. GATES IT GmbH </mat-card-subtitle>
                  <mat-card-content>
                    <div>
                      <mat-form-field>
                        <input matInput [(ngModel)]="client.name" (input)="basicDataHasChanged = true;">
                      </mat-form-field>
                    </div>

                  </mat-card-content>
                  <mat-card-actions>
                    <button mat-button (click)="saveBasicData()" color="primary"
                      [disabled]="!basicDataHasChanged">Speichern</button>
                  </mat-card-actions>
                </mat-card>
              </div>


              <div class="col-sm-6">
                <mat-card appearance="outlined" class="example-card">
                  <mat-card-title> Unternehmens-Webseite</mat-card-title>
                  <mat-card-subtitle> Unternehmens-Webseite des Clients bspw. https://gates-it.de </mat-card-subtitle>
                  <mat-card-content>
                    <div>
                      <mat-form-field>
                        <input matInput [(ngModel)]="client.website" (input)="basicDataHasChanged = true;">
                      </mat-form-field>
                    </div>

                  </mat-card-content>
                  <mat-card-actions>
                    <button mat-button (click)="saveBasicData()" color="primary"
                      [disabled]="!basicDataHasChanged">Speichern</button>

                  </mat-card-actions>
                </mat-card>
              </div>
            </div>

            <div class="row">
              <div class="col-sm-6">
                <mat-card appearance="outlined" class="example-card">
                  <mat-card-title> Adresse</mat-card-title>
                  <mat-card-subtitle> Adresse des Clients </mat-card-subtitle>
                  <mat-card-content>
                    <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="25px" fxLayout.lt-md="column">
                      <mat-form-field>
                        <mat-label>Straße:</mat-label>
                        <input matInput [(ngModel)]="address.street" (input)="addressHasChanged = true;">
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>PLZ:</mat-label>
                        <input matInput [(ngModel)]="address.postcode" (input)="addressHasChanged = true;">
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Ort:</mat-label>
                        <input matInput [(ngModel)]="address.city" (input)="addressHasChanged = true;">
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Breitengrad:</mat-label>
                        <input matInput [(ngModel)]="address?.location.lat" (input)="addressHasChanged = true;">
                      </mat-form-field>
                      <mat-form-field>
                        <mat-label>Längengrad:</mat-label>
                        <input matInput [(ngModel)]="address?.location.lng" (input)="addressHasChanged = true;">
                      </mat-form-field>
                      <button *ngIf="addressHasChanged" mat-stroked-button color="primary" (click)="saveAddress()">
                        <mat-icon>save</mat-icon>
                        Speichern
                      </button>
                    </div>
                  </mat-card-content>
                  <mat-card-actions>
                    <button mat-button (click)="saveBasicData()" color="primary"
                      [disabled]="!basicDataHasChanged">Speichern</button>
                    <button mat-button color="primary" (click)="getCoordinates()">
                      Koordinaten ermitteln
                    </button>
                  </mat-card-actions>
                </mat-card>
              </div>
              <div class="col-sm-6">
                <mat-card appearance="outlined" class="example-card">
                  <mat-card-title> Öffnungszeiten</mat-card-title>
                  <mat-card-subtitle> Öffnungszeiten des Clients </mat-card-subtitle>
                  <mat-card-content>
                    <div class="row actionRow" *ngFor="let hour of officeHours; let i = index">
                      <div class="col-lg-8">
                        <mat-form-field>
                          <input matInput [(ngModel)]="hour.value" (input)="officeHours[i].hasChanged = true;">
                        </mat-form-field>
                      </div>
                      <div class="col-lg-2">
                        <button mat-button color="warn" (click)="removeHour(i)" fxFlex="40%">
                          Entfernen
                        </button>
                      </div>
                      <div class="col-lg-2">
                        <button mat-button color="primary" (click)="saveOfficeHours()" fxFlex="40%"
                          [disabled]="!officeHours[i].hasChanged">
                          Speichern
                        </button>
                      </div>
                    </div>
                  </mat-card-content>
                  <mat-card-actions>
                    <button mat-button color="primary" (click)="addOfficeHourRow()">
                      Hinzufügen
                    </button>
                  </mat-card-actions>
                </mat-card>
              </div>

            </div>
          </div>
        </mat-tab>

        <mat-tab label="Parameter">

          <div class="row" style="margin-top: 35px;">
            <div class="col-lg-12" *ngFor="let p of clientConfiguration; let i = index">
              <mat-card appearance="outlined" class="example-card">
                <mat-card-title> {{ p.displayName }}</mat-card-title>
                <mat-card-content>
                  <mat-form-field>
                    <input matInput [placeholder]="p.defaultValue" [(ngModel)]="p.value" (input)="p.changed = true;">
                  </mat-form-field>
                  <p style="padding: 10px 0;">
                    {{ p.description }}
                  </p>
                </mat-card-content>
                <mat-card-actions>
                  <button mat-button color="primary" (click)="saveProperty(p)" [disabled]="!p.changed">
                    Speichern
                  </button>
                </mat-card-actions>
              </mat-card>
            </div>
          </div>

        </mat-tab>

        <mat-tab label="Rechtliches">
          <mat-card appearance="outlined" class="example-card" *ngFor="let legal of legalSections; let i = index;" style="margin-top: 35px;">
            <mat-card-title> {{ legal.title }} </mat-card-title>
            <mat-card-content>
               <ckeditor [editor]="Editor" [config]="config" style="display:inline-block;width: 100%;min-height: 350px;height: 450px;"  [(ngModel)]="legalInformation[i]"  (change)="legalEditorChanged($event, i)"></ckeditor>

            </mat-card-content>
            <mat-card-actions>
              <button mat-button color="primary" (click)="saveLegal(i, legal.key)" [disabled]="!legalHasChanged[i]">
                Speichern
              </button>
            </mat-card-actions>
          </mat-card>



        </mat-tab>
        
        <mat-tab label="Services">

          <mat-card appearance="outlined" class="example-card" style="margin-top: 35px;">
            <mat-card-title> Service finden</mat-card-title>
            <mat-card-content>
              <app-service-filter (filterChanged)="serviceFilterChanged($event)"></app-service-filter>
            </mat-card-content>
          </mat-card>


          <mat-card appearance="outlined" class="example-card" style="margin-top: 35px;">
            <mat-card-title>       Service Konfiguration</mat-card-title>
            <mat-card-content>
          
      

            <table class="table table-striped margin-top">
              <thead>
                <tr>
                  <th>Aktiv</th>
                  <th>Service</th>
                  <th>Verfügbar für</th>
                  <th>Wert</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let s of services | sort:'path' | serviceFilter:serviceFilter; let i = index;">
                  <td>
                    <mat-checkbox [(ngModel)]="s.active" (change)="updateContractStatus(s)">
                    </mat-checkbox>
                  </td>
                  <td>{{ s.name }}<br>{{ s.path }}</td>
                  <td>
                    {{ s.permission | permissionDisplayName}}
                  </td>
                  <td>
                    <mat-form-field *ngIf="s.hasValue">
                      <input matInput [(ngModel)]="s.value" (input)="serviceHasChanged[i] = true;">
                    </mat-form-field>

                    <button mat-button color="primary" (click)="updateContract(s)" fxFlex="40%"
                      *ngIf="serviceHasChanged[i]">
                      <mat-icon>save</mat-icon>
                      Speichern
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            </mat-card-content>
          </mat-card>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>